import React, { Component } from "react";
import { connect } from "react-redux";
import { addNewAddress } from "../store/actions/customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ililce from "../helpers/ililce";
import styles from "../thema/style";
import "animate.css/animate.min.css";
import moment from "moment";
import "moment/locale/tr";

export default class FloatingWhatsApp extends Component {
  state = {
    notification: false,
    translateValue: 800, // Başlangıçta translateX değeri -1000 olacak
  };

  //   constructor(props) {
  //     super(...props);
  //     console.log("--->", props);
  //   }

  componentDidMount() {
    // console.log("WOW", new WOW().ini);
    // new WOW.init();
    setTimeout(() => {
      this.setState({ notification: true });
    }, 3500);

    setTimeout(() => {
      this.setState({ translateValue: 0 });
    }, 4000);
  }

  render() {
    const { translateValue } = this.state;
    const divStyle = {
      opacity: translateValue === 800 ? 0 : 1,

      transform: `translateX(${translateValue}px) scale(${
        translateValue === 800 ? 0.6 : 1
      })`,

      transition: "all 1s ease", // 1 saniyede -1000px'den 0px'e geçiş yap
      // Diğer stil özelliklerini buraya ekleyin
    };

    return (
      <a target={"_blank"} href={`https://wa.me/${this.props.phoneNumber}`}>
        <div className={"wp-float"}>
          <div className={"wp-button"}>
            {this.state.notification ? <span>1</span> : null}
            <FontAwesomeIcon
              icon={["fab", "whatsapp"]}
              className={"my-float"}
            />
          </div>

          <div
            // className={"msg-wrapper wow fadeInRight"}
            className={"msg-wrapper"}
            data-wow-delay="4s"
            style={divStyle}
          >
            <div className="msg">
              <div className="bubble">
                <div className="txt">
                  <span className="name">{this.props.title}</span>
                  {/* <span className="name">Dt. Pınar Kahraman</span> */}
                  <span className="timestamp">
                    {moment(new Date()).format("LT")}
                  </span>
                  <span className="message">{this.props.content}</span>
                </div>
                <div class="bubble-arrow alt"></div>
              </div>
            </div>
          </div>
        </div>
      </a>
    );
  }
  //   state = {
  //     full_name: "",
  //     city: "",
  //     town: "",
  //     postal_code: "",
  //     address: "",
  //     phone: "",
  //     address_name: "",
  //   };

  //   constructor(props) {
  //     super(props);
  //     this.close = React.createRef();
  //   }

  //   handleChange = (e) => {
  //     this.setState({ [e.target.name]: e.target.value });
  //   };

  //   onSubmit = (e) => {
  //     e.preventDefault();
  //     this.props.addNewAddress({ ...this.state });
  //     this.close.current.click();
  //   };

  //   render() {
  //     return (
  //       <div
  //         className="modal fade"
  //         id="exampleModal"
  //         tabindex="-1"
  //         role="dialog"
  //         aria-labelledby="exampleModalLabel"
  //         aria-hidden="true"
  //       >
  //         <div className="modal-dialog" role="document">
  //           <div className="modal-content">
  //             <div className="modal-header">
  //               <h5 className="modal-title" id="exampleModalLabel">
  //                 Yeni Adres Ekle
  //               </h5>
  //               <button
  //                 type="button"
  //                 className="close"
  //                 data-dismiss="modal"
  //                 aria-label="Close"
  //               >
  //                 <span aria-hidden="true">&times;</span>
  //               </button>
  //             </div>
  //             <form onSubmit={this.onSubmit}>
  //               <div className="modal-body">
  //                 <div className="form-group">
  //                   <label>Adres Adı</label>
  //                   <input
  //                     required
  //                     type="text"
  //                     className="form-control"
  //                     name={"address_name"}
  //                     defaultValue={this.state.address_name}
  //                     onChange={(e) => {
  //                       this.handleChange(e);
  //                     }}
  //                   />
  //                 </div>
  //                 <div className="form-group">
  //                   <label>Ad Soyad</label>
  //                   <input
  //                     required
  //                     type="text"
  //                     className="form-control"
  //                     name={"full_name"}
  //                     defaultValue={this.state.full_name}
  //                     onChange={(e) => {
  //                       this.handleChange(e);
  //                     }}
  //                   />
  //                 </div>
  //                 <div className="form-group">
  //                   <div className="row">
  //                     <div className="col-md-6">
  //                       <label>İl</label>
  //                       <select
  //                         required
  //                         className="form-control"
  //                         name={"city"}
  //                         onChange={(e) => {
  //                           this.handleChange(e);
  //                         }}
  //                       >
  //                         <option value=""> --Seçiniz-- </option>
  //                         {ililce.map((item, i) => (
  //                           <option key={i} value={item.il}>
  //                             {item.il}
  //                           </option>
  //                         ))}
  //                       </select>
  //                     </div>
  //                     <div className="col-md-6">
  //                       <label>İlçe</label>
  //                       <select
  //                         required
  //                         className="form-control"
  //                         name={"town"}
  //                         onChange={(e) => {
  //                           this.handleChange(e);
  //                         }}
  //                       >
  //                         <option value=""> --Seçiniz-- </option>
  //                         {this.state.city != "" &&
  //                           ililce
  //                             .find((item) => item.il === this.state.city)
  //                             .ilceleri.map((item) => (
  //                               <option value={item}>{item}</option>
  //                             ))}
  //                       </select>
  //                     </div>
  //                   </div>
  //                 </div>

  //                 <div className="form-group">
  //                   <div className="row">
  //                     <div className="col-md-3">
  //                       <label>Posta Kodu</label>
  //                       <input
  //                         required
  //                         type="text"
  //                         className="form-control"
  //                         name={"postal_code"}
  //                         defaultValue={this.state.postal_code}
  //                         onChange={(e) => {
  //                           this.handleChange(e);
  //                         }}
  //                       />
  //                     </div>
  //                     <div className="col-md-9">
  //                       <label>İletişim Telefon</label>
  //                       <input
  //                         required
  //                         type="text"
  //                         className="form-control"
  //                         name={"phone"}
  //                         defaultValue={this.state.phone}
  //                         onChange={(e) => {
  //                           this.handleChange(e);
  //                         }}
  //                       />
  //                     </div>
  //                   </div>
  //                 </div>

  //                 <div className="form-group">
  //                   <label>Adres</label>
  //                   <textarea
  //                     required
  //                     rows="3"
  //                     type="text"
  //                     className="form-control"
  //                     name={"address"}
  //                     defaultValue={this.state.address}
  //                     onChange={(e) => {
  //                       this.handleChange(e);
  //                     }}
  //                   />
  //                 </div>
  //               </div>
  //               <div className="modal-footer">
  //                 <button
  //                   ref={this.close}
  //                   type="button"
  //                   className="btn btn-secondary"
  //                   data-dismiss="modal"
  //                 >
  //                   İptal
  //                 </button>
  //                 <button type="submit" className="btn btn-success">
  //                   Kaydet
  //                 </button>
  //               </div>
  //             </form>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }
}

// const mapStateToProps = ({ customer }) => {
//   return { customer };
// };

// const mapDispatchToProps = { addNewAddress };

// export default connect(mapStateToProps, mapDispatchToProps)(FloatingWhatsApp);



// WEBPACK FOOTER //
// ./src/components/FloatingWhatsApp.js